/** Read-only, response-scoped provider projection. */

import { getData } from '~/utils/service';
import type { ProviderViewResponse } from './types';

export const fetchProviderView = async (
  providerId: number,
  responseId?: number
): Promise<ProviderViewResponse> => {
  return getData<ProviderViewResponse>('hlxProviderView', {
    pathParams: { providerId: providerId.toString() },
    params: responseId ? { response_id: responseId } : undefined,
  });
};

export const fetchProviderViewByResponseProvider = async (
  responseProviderId: number
): Promise<ProviderViewResponse> => {
  return getData<ProviderViewResponse>('hlxProviderViewByResponseProvider', {
    pathParams: { responseProviderId: responseProviderId.toString() },
  });
};

/** Always-masked vault for a public listing found through Search Providers. */
export const fetchProviderViewByServiceListing = async (
  serviceListingId: number
): Promise<ProviderViewResponse> => {
  return getData<ProviderViewResponse>('hlxProviderViewByServiceListing', {
    pathParams: { serviceListingId: serviceListingId.toString() },
  });
};
